import { render } from "./DButton.vue?vue&type=template&id=22232fa8&scoped=true"
import script from "./DButton.vue?vue&type=script&lang=js"
export * from "./DButton.vue?vue&type=script&lang=js"

import "./DButton.vue?vue&type=style&index=0&id=22232fa8&lang=scss&scoped=true"

import exportComponent from "/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22232fa8"]])

export default __exports__